import React from 'react'

const wrapperStyle = {
  display: 'inline-block',
  position: 'relative',
}
const iconStyle = {
  display: 'inline-block',
  cursor: 'pointer',
  marginLeft: '5px',
}



class HelpTextComp extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showPopup: this.props.autoOpen || false,
    }

    this.mouseEnter = this.mouseEnter.bind(this)
    this.mouseLeave = this.mouseLeave.bind(this)
    this.showHideElement = this.showHideElement.bind(this)
    this.handleShowPopup = this.handleShowPopup.bind(this)
    this.helpTextCompRef = React.createRef()
    this.showPopupRef = React.createRef()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.autoOpen !== this.props.autoOpen) {
      this.setState({ showPopup: this.props.autoOpen })
    }
  }

  // eslint-disable-next-line no-unused-vars
  mouseEnter(e, val) {
    if (val === "keyPress") {
      this.setState(prevState => ({
        showPopup: !prevState.showPopup
      }))
    } else {
      this.setState({ showPopup: true })
    }

    const { cascadeHelpText, cascadeHelpTextPlace } = this.props
    if (cascadeHelpText || cascadeHelpTextPlace) {
      if (document.querySelector('.helptextcomp-form-popup')) {
        const top = cascadeHelpText ? '-145px' : '-120px'
        document.querySelector('.helptextcomp-form-popup').style.top = top
      }
    } else {
      if (document.querySelector('.kr-modal-content')) {
        document.querySelector('.helptextcomp-wrapper').style.borderBottom =
          '100px'
      }
      // if (document.querySelector(".krRightPaneContent")) {
      // 	// let el = document.querySelector(".krRightPaneContent");
      // 	// el.style.top = el.scrollHeight - 150;
      // 	// el.style.transition = "top 1s linear";
      // 	$(".krRightPaneContent").animate({
      // 		scrollTop: $(".krRightPaneContent")[0].scrollHeight - 150
      // 	});
      // }
    }
  }

  // eslint-disable-next-line no-unused-vars
  mouseLeave(e) {
    if (!this.props.autoOpen) {
      this.setState({ showPopup: false })
    }
  }

  handleShowPopup(e) {
    if (e.type === "click" || e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      this.mouseEnter(e, 'keyPress')
    } else if (e.key === "Escape" || e.key === "Tab" || (e.shiftKey && e.key === "Tab")) {
      e.stopPropagation();
      this.mouseLeave(e)
    }
  }

  showHideElement(e) {
    const { showOptions } = this.state
    if (
      this.helpTextCompRef &&
      !this.helpTextCompRef.current.contains(e.target)
    ) {
      this.setState({ showPopup: false })
    } else if (!showOptions) {
      this.setState({ showPopup: true })
    }
  }

  render() {
    const { showPopup } = this.state
    const { children, compStyle = false } = this.props
    if (compStyle) {
      wrapperStyle = {
        marginTop: '3px',
        marginBottom: '0px',
        display: 'inline-block',
        position: 'relative',
      }
    }
    return (
      <div 
        className={`helptextcomp-wrapper ${this.props.wrapperClass}`} 
        onMouseEnter={(e) => this.mouseEnter(e)}
        onMouseLeave={(e) => this.mouseLeave(e)}
      >
        
        <div
          className="icon icon-outline-help_outline-14px helptextcomp-icon"
          tabIndex="0"
          role="button"
          aria-label="Help"
          aria-describedby='help-tooltip-content'
          onClick={(e) => this.handleShowPopup(e)}
          onKeyDown={(e) => this.handleShowPopup(e)}
        ></div>

        {showPopup && (
          <div className={`helptextcomp-form-popup ${this.props.popUpClass}`} id="help-tooltip-content">
            <div
              className={`helptextcomp-form-popup-content ${this.props.popUpContentClass}`}
            >
              {children}
            </div>
          </div>
        )}
      </div>
    )
  }
}
HelpTextComp.defaultProps = {
  wrapperClass: '',
  autoOpen: false,
  popUpContentClass: '',
  popUpClass: '',
}
export default HelpTextComp
